import { INFORMATION_AGENT, PLAN_ADMINISTRATOR, HR_CLERK } from "../Roles";

const API_VERSION = "v1";
const API_VERSION_V2 = "v2";

export const GRAPHQL = {
    path: "/graphql",
};
export const ACTIVE_BILLING_PERIODS = {
    name: "activeBillingPeriods",
    identifier: "billingPeriodId",
    path: `/${API_VERSION}/billing-periods`,
    localizedFields: ["name"],
};

export const LATEST_MEMBER_SYNCS = {
    name: "latestSyncs",
    path: `/${API_VERSION}/clients/{}/get-latest-syncs`
};

export const LATEST_MEMBER_SYNCS_V2 = {
    name: "latestSyncs",
    path: `/${API_VERSION_V2}/clients/{}/get-latest-member-syncs`
};

export const IS_MEMBER_COVERAGE_SYNCHRONIZED = {
    name: "isMemberCoverageSynchronized",
    path: `/${API_VERSION_V2}/member-coverage-sync/{}/is-synchronized`
};

export const IS_DEPENDENT_COVERAGE_SYNCHRONIZED = {
    name: "isDependentCoverageSynchronized",
    path: `/${API_VERSION_V2}/dependent-person-coverage-sync/{}/is-synchronized`
};

export const CLIENT_SYNCS = {
    name: "clientSyncs",
    path: `/${API_VERSION_V2}/clients/{}/sync`
};

export const LATEST_DEPENDENT_PERSON_SYNCS = {
    name: "latestDependentPersonSyncs",
    path: `/${API_VERSION_V2}/clients/{}/get-latest-dependent-person-syncs`
};

export const AUDITS = {
    name: "audits",
    identifier: "auditId",
    path: `/${API_VERSION}/audits`,
};
export const BILLING_PERIODS = {
    name: "billingPeriods",
    identifier: "billingPeriodId",
    path: `/${API_VERSION}/billing-periods`,
    localizedFields: ["name"],
};
export const BILLING_PERIODS_CLIENT_ALL = {
    name: "billingPeriodsClientAll",
    identifier: "billingPeriodId",
    path: `/${API_VERSION}/billing-periods`,
    localizedFields: ["name"],
};
export const CLASSES = {
    name: "classes",
    identifier: "classId",
    path: `/${API_VERSION}/classes`,
    archiveFilter: "classes.isArchived==false",
};
export const CLIENTS = {
    name: "clients",
    identifier: "clientId",
    path: `/${API_VERSION}/clients`,
    archiveFilter: "clients.isArchived==false",
    manualFilter: "clients.clientBillingPeriodType==MANUAL",
    recurringFilter: "clients.clientBillingPeriodType==RECURRING",
    classificationFilter: "clients.isVip==true",
    notTerminatedFilter: "clients.clientStatusType!=TERMINATED",
    inBlocFilter: (blocIds) => `clients.blocId=in=(${blocIds})`,
    localizedFields: ["withdrawalFormMessage"],
};
export const CLIENTS_V2 = {
    ...CLIENTS,
    path: `/${API_VERSION_V2}/clients/table`,
};

export const CLIENT_V2 = {
    ...CLIENTS,
    path: `/${API_VERSION_V2}/clients`
};
export const GET_CLIENT_V2 = {
    ...CLIENTS,
    path: `/${API_VERSION_V2}/clients/{}`
};
export const BROKERS = {
    name: "brokers",
    identifier: "brokerId",
    path: `/${API_VERSION}/brokers`,
    archiveFilter: "isArchived==false",
    creationDateSorter: "createdAt:desc",
};
export const ACCOUNTS = {
    name: "accounts",
    identifier: "accountId",
    path: `/${API_VERSION}/accounts`,
};
export const BLOC_CLIENTS = {
    ...CLIENTS,
    name: "blocClients",
};
export const CLIENT_COVERAGES = {
    name: "clientCoverages",
    identifier: "clientCoverageId",
    path: `/${API_VERSION}/client-coverages`,
    archiveFilter: "clientCoverages.isArchived==false",
    localizedFields: ["administrator"],
};
export const COVERAGE_GROUPS = {
    name: "coverageGroups",
    identifier: "withdrawalId",
    path: `/${API_VERSION}/withdrawals`,
    archiveFilter: "withdrawals.isArchived==false",
    localizedFields: ["name", "emailMessage"],
};
export const GROUPED_COVERAGES = {
    name: "groupedCoverages",
    identifier: "withdrawalClientCoverageId",
    path: `/${API_VERSION}/withdrawal-client-coverages`,
};
export const MEMBER_COVERAGES = {
    name: "memberCoverages",
    identifier: "memberCoverageId",
    path: `/${API_VERSION}/member-coverages`,
};
export const COVERAGE = {
    name: "coverage",
    identifier: "coverageId",
    path: `/${API_VERSION}/coverage`,
    archiveFilter: "",
};
export const CONFIGURATIONS = {
    name: "configurations",
    identifier: "configurationId",
    path: `/${API_VERSION}/configurations`,
    archiveFilter: "",
};
export const ACCOUNTPAYABLES = {
    name: "accountPayables",
    identifier: "accountPayableId",
    path: `/${API_VERSION}/account-payables`,
    archiveFilter: "",
};
export const ACCOUNTRECIEVABLES = {
    name: "accountRecievables",
    identifier: "accountRecievableId",
    path: `/${API_VERSION}/account-recievables`,
    archiveFilter: "",
};
export const ACCOUNTBUSINESSUNITS = {
    name: "accountBusinessUnits",
    identifier: "accountBusinessUnitId",
    path: `/${API_VERSION}/account-business-units`,
    archiveFilter: "",
};
export const ACCOUNTBUSINESSUNITS_V2 = {
    ...ACCOUNTBUSINESSUNITS,
    path: `/${API_VERSION_V2}/account-business-units`,
};
export const ACCOUNTPROVINCES = {
    name: "accountProvinces",
    identifier: "accountProvinceId",
    path: `/${API_VERSION}/account-provinces`,
    archiveFilter: "",
};
export const DIVISIONS = {
    name: "divisions",
    identifier: "divisionId",
    path: `/${API_VERSION}/divisions`,
    archiveFilter: "divisions.isArchived==false",
};
export const CLIENT_ATTACHMENTS = {
    name: "clientAttachments",
    identifier: "clientAttachmentId",
    path: `/${API_VERSION}/client-attachments`,
    signingPath: `/${API_VERSION}/aws/signed-url`,
};
export const FOLLOW_UPS = {
    name: "followUps",
    identifier: "followUpId",
    path: `/${API_VERSION}/follow-ups`,
    archiveFilter: "followUps.followUpStatusType==OPEN",
    closedFilter: "followUps.followUpStatusType==CLOSED",
    classificationFilter: "followUps.isVip==true"
};
export const CLIENT_FOLLOW_UPS = {
    name: "clientFollowUps",
    identifier: "followUpId",
    path: `/${API_VERSION}/follow-ups`,
    archiveFilter: "followUps.followUpStatusType==OPEN",
};
export const FOLLOW_UP_ATTACHMENTS = {
    name: "followUpAttachments",
    identifier: "followUpAttachmentId",
    path: `/${API_VERSION}/follow-up-attachments`,
    signingPath: `/${API_VERSION}/aws/signed-url`,
};
export const FOLLOW_UP_COMMENTS = {
    name: "followUpComments",
    identifier: "followUpCommentId",
    path: `/${API_VERSION}/follow-up-comments`,
};
export const FOLLOW_UP_CATEGORIES = {
    name: "followUpCategories",
    identifier: "followUpCategoryId",
    path: `/${API_VERSION}/follow-up-categories`,
};
export const GUARANTEES = {
    name: "guarantees",
    identifier: "guaranteeId",
    path: `/${API_VERSION}/guarantees`,
    archiveFilter: "guarantees.isArchived==false",
    localizedFields: ["name", "shortName"],
};
export const GROUPS = {
    name: "groups",
    identifier: "groupId",
    path: `/${API_VERSION_V2}/groups`,
    archiveFilter: "groups.isArchived==false",
};
export const INSURERS = {
    name: "insurers",
    identifier: "insurerId",
    path: `/${API_VERSION}/insurers`,
    archiveFilter: "insurers.isArchived==false",
    localizedFields: ["name"],
};
export const INVOICES = {
    name: "invoices",
    identifier: "invoiceId",
    path: `/${API_VERSION}/invoices`,
    publishFilter: "invoices.isPublished==true",
    noFailuresFilter: "invoices.invoiceStatusType!=FAILURE",
};
export const MEMBERS = {
    name: "members",
    identifier: "memberId",
    path: `/${API_VERSION}/members`,
    archivedFilter: "members.isArchived==true",
    notArchivedFilter: "members.isArchived==false",
    fetching: false
};
export const SYNC_NOTIFICATIONS_GRAPHQL = {
    ...GRAPHQL,
    name: "syncedData",
    onlyMyModificationsFilter: "onlyMyModifications==true",
    onlyErrorsFilter: "onlyErrors==true",
    getEligibilityFilter: "getEligibility==true",
    defaultSort: "syncDate:desc",
};
export const MEMBERS_GRAPHQL = {
    ...GRAPHQL,
    name: "members",
    archiveFilter: "members.isArchived==false",
};
export const MEMBER_TABLE = {
    ...MEMBERS,
    path: `/${API_VERSION_V2}/members/table`,
    inactiveFilter: "members.isInactive==false",
};
export const MESSAGES = {
    name: "messages",
    identifier: "messageId",
    path: `/${API_VERSION}/messages`,
};
export const SALES_TAXES = {
    name: "salesTaxes",
    identifier: "salesTaxId",
    path: `/${API_VERSION}/sales-taxes`,
};
export const USERS = {
    name: "users",
    identifier: "userId",
    path: `/${API_VERSION}/users`,
    archiveFilter: "users.isArchived==false",
    informationAgentFilter: `users.roleId!=${INFORMATION_AGENT.roleId}`,
    planManagerFilter: `users.roleId!=${PLAN_ADMINISTRATOR.roleId}`,
    hrClerkFilter: `users.roleId!=${HR_CLERK.roleId}`,
};
export const USERS_V2 = {
    ...USERS,
    path: `/${API_VERSION_V2}/users`,
};
export const DEPENDENTS = {
    name: "dependents",
    identifier: "dependentPersonId",
    path: `/${API_VERSION}/dependent-persons`,
    archiveFilter: "dependentPersons.isArchived==false",
};
export const DEPENDENT_COVERAGES = {
    name: "dependentCoverages",
    identifier: "dependentPersonCoverageId",
    path: `/${API_VERSION}/dependent-person-coverages`,
};
export const BENEFICIARIES = {
    name: "beneficiaries",
    identifier: "beneficiaryId",
    path: `/${API_VERSION}/beneficiaries`,
    archiveFilter: "beneficiaries.isArchived==false",
};
export const BLOCS = {
    name: "blocs",
    identifier: "blocId",
    path: `/${API_VERSION}/blocs`,
    archiveFilter: "blocs.isArchived==false",
};
export const BLOCS_V2 = {
    ...BLOCS,
    path: `/${API_VERSION_V2}/blocs`,
};
export const INVOICE_DATA = {
    name: "invoiceData",
    identifier: "invoiceDatumId",
    path: `/${API_VERSION}/invoice-data`,
    archiveFilter: "invoiceData.isArchived==false",
    canceledFilter: "invoiceStatusType!=CANCELED",
    finalStatusType: "invoiceStep==FINAL",
    generatedFilter: "invoiceStatusType==GENERATED",
};

export const INVOICES_TABLE = {
    name: "invoiceDataFront",
    identifier: "invoiceDataFrontId",
    path: `/${API_VERSION}/invoices/table`,
};

export const INVOICE_REVIEW = {
    name: "invoiceReview",
    identifier: "invoiceId",
    path: `/${API_VERSION}/invoices/{}/review`,
};

export const BILLING_PERIOD_LAST_VALID_INVOICE = {
    name: "billingPeriodLastValidInvoice",
    identifier: "billingPeriodId",
    path: `/${API_VERSION}/invoices/{}/get-last-valid-invoice-for-billing-period`,
};

export const GET_LAST_VALID_TEMPLATE_INVOICE = {
    path: `/${API_VERSION}/invoices/{}/get-last-valid-template-invoice`,
};

export const GET_TEMPLATE_MISSING_FIELDS_FOR_CLIENT = {
    path: `/${API_VERSION}/invoices/{}/get-template-missing-fields-for-client`,
};

export const GET_TEMPLATE_MISSING_FIELDS = {
    name: "getTemplateMissingFields",
    identifier: "invoiceId",
    path: `/${API_VERSION}/invoices/{}/get-template-missing-fields`,
};

export const INVOICE_ATTACHMENTS = {
    name: "invoiceAttachments",
    identifier: "invoiceAttachmentId",
    path: `/${API_VERSION}/invoice-attachments`,
    signingPath: `/${API_VERSION}/aws/signed-url`,
};

export const EXPORTS = {
    name: "exports",
    identifier: "exportId",
    path: `/${API_VERSION}/exports`,
    signingPath: `/${API_VERSION}/aws/signed-url`,
};

export const CLIENT_BROKER_RELATIONSHIP = {
    name: "clientBrokerRelationship",
    identifier: "clientBrokerRelationshipId",
    getPath: (id) => `/${API_VERSION}/clients/${id}/brokers`,
    archiveFilter: "isArchived==false",
};
export const SUPPLIERS_REPORTS = {
    name: "reports",
    identifier: "reportId",
    path: `/${API_VERSION}/reports`,
    signingPath: `/${API_VERSION}/aws/signed-url`,
};
export const RECEIVABLE_REPORTS = {
    name: "receivableReports",
    identifier: "invoiceId",
    path: `/${API_VERSION}/receivable-reports`,
    archiveFilter: "",
};
export const PAYABLE_REPORTS = {
    name: "payableReports",
    identifier: "rowNumber",
    path: `/${API_VERSION}/payable-reports`,
    archiveFilter: "",
};
export const COVERAGE_PERIODS = {
    name: "coveragePeriods",
    identifier: "coveragePeriodId",
    path: `/${API_VERSION}/coverage-periods`,
    archiveFilter: "",
};
export const CLIENT_HISTORIES = {
    name: "clientHistories",
    identifier: "clientHistoryId",
    path: `/${API_VERSION}/client-histories`,
    archiveFilter: "",
};

export const ACCOUNTING_EXPORTS = {
    name: "accountingExports",
    identifier: "exportId",
    path: `/${API_VERSION}/exports`,
    signingPath: `/${API_VERSION}/aws/signed-url`,
};

export const FOLLOW_UPS_TABLE = {
    ...FOLLOW_UPS,
    path: `/${API_VERSION_V2}/follow-ups/table`,
};
export const FOLLOW_UPS_GRAPHQL = {
    ...GRAPHQL,
    name: "followUps",
    archiveFilter: "follow_ups.follow_up_status_type==OPEN",
};

export const FOLLOW_UPS_GRAPHQL_MEMBERS = {
    ...GRAPHQL,
    name: "followUpsMembers",
    key: "followUps",
    archiveFilter: "follow_ups.follow_up_status_type==OPEN",
};


export const CLIENTS_GRAPHQL = {
    ...GRAPHQL,
    name: "clients",
    archiveFilter: "clients.is_archived==false",
    nonMEVClientsFilter: "clients.client_status_type!=IMPLEMENTATION",
    currentClientsFilter: "clients.client_status_type=notin=['INACTIVE','TERMINATED']",
    defaultSort: "clients.name:asc",
};

// Separate Redux key for the clients dropdown list, so it doesn't conflict with state.data.clients.active
export const CLIENTS_DROPDOWN_GRAPHQL = {
    ...GRAPHQL,
    name: "clientsDropdown",
    key: "clients",
    archiveFilter: "clients.is_archived==false",
    defaultSort: "clients.name:asc",
};

export const CLIENTS_TABLE_GRAPHQL = {
    ...GRAPHQL,
    name: "clientsTable",
    archiveFilter: "clients.isArchived==false",
    nonMEVClientsFilter: "clients.client_status_type!=IMPLEMENTATION",
    currentClientsFilter: "clients.client_status_type=notin=['INACTIVE','TERMINATED']",
    defaultSort: "clients.name:asc",
    identifier: "clientId",
    manualFilter: "clients.clientBillingPeriodType==MANUAL",
    recurringFilter: "clients.clientBillingPeriodType==RECURRING",
    classificationFilter: "clients.isVip==true",
    notTerminatedFilter: "clients.clientStatusType!=TERMINATED",
    inBlocFilter: (blocIds) => `clients.blocId=in=(${blocIds})`,
    localizedFields: ["withdrawalFormMessage"],
};

export const USERS_GRAPHQL = {
    ...GRAPHQL,
    name: "users",
    archiveFilter: "users.is_archived==false",
    defaultSort: "users.username:asc",
};

export const PERSONAL_DATA_CONFIGURATION = {
    name: "personalDataConfiguration",
    identifier: "clientId",
    path: `/${API_VERSION}/member-personal-data`,
};

export const PERSONAL_DATA_CONFIGURATION_FIELDS = {
    name: "personalDataConfiguration",
    identifier: "clientId",
    path: `/${API_VERSION}/member-personal-data-fields`,
};

export const PERSONAL_DATA_CONFIGURATION_MESSAGES = {
    name: "personalDataConfigurationMessages",
    identifier: "clientId",
    path: `/${API_VERSION}/member-personal-data-localizations`,
};

export const CLIENT_CHANGE_STATUS = {
    path: `/${API_VERSION}/clients/{}/change-status/`,
};
export const CLIENT_CHANGE_STATUS_VALIDATION = {
    path: `/${API_VERSION}/clients/{}/change-status/`,
};

export const CLIENT_LIFECYCLE_BY_CLIENT_ID = {
    path: `/${API_VERSION}/client-lifecycles/{}`,
};

export const PERSONAL_DATA_FORM = {
    path: `/${API_VERSION}/clients/{}/personal-data`,
};

export const WITHDRAWAL_FORM = {
    path: `/${API_VERSION}/clients/{}/withdrawal`,
};

export const GET_CLIENT_STATUS_TYPE = {
    path: `/${API_VERSION}/clients/{}/client-status-type`,
};

export const IS_CLIENT_ARCHIVED = {
    path: `/${API_VERSION}/clients/{}/is-client-archived`,
};

export const MAJOR_CODE_RECUPERATION = {
    path: `/${API_VERSION}/clients/{}/major-code-recuperation`,
};

export const PATCH_INVOICING_CONFIG = {
    path: `/${API_VERSION}/clients/{}/invoicing`,
};

export const GET_RETROACTIVE_LIMIT_DATE = {
    path: `/${API_VERSION}/clients/{}/get-retroactive-limit-date`,
};

export const GET_MENROL_EXIST = {
    path: `/${API_VERSION}/referential-data/menrol-status`,
};

export const USER_MFA = {
    path: `/${API_VERSION}/users/{}/mfa-preference`,
};

export const GET_RETROACTIVE_CREDITS = {
    path: `/${API_VERSION}/clients/{}/get-retroactive-credits`,
};

export const TAX_NUMBERS = {
    name: "taxNumbers",
    identifier: "taxNumberId",
    path: `/${API_VERSION}/tax-numbers`,
};

export const CLIENT_CONTACTS = {
    name: "clientContacts",
    identifier: "clientContactId",
    path: `/${API_VERSION}/clients/{}/contacts`,
};

export const MEMBER_LAST_SYNC = {
    name: "memberLastSync",
    path: `/${API_VERSION}/clients/{clientId}/members/{memberId}/last-sync`,
};

export const MEMBER_COVERAGE_SYNCS = {
    path: `/${API_VERSION}/clients/{}/members/coverages/sync`,
};

export const DEPENDENT_PERSON_SYNCS = {
    path: `/${API_VERSION}/clients/{clientId}/members/{memberId}/dependent-persons/sync`,
};

export const DEPENDENT_PERSON_COVERAGE_SYNCS = {
    path: `/${API_VERSION}/clients/{}/dependent-persons/coverages/sync`,
};

export const PROCESS_SYNC = {
    name: "processSyncs",
    identifier: "processSyncId",
    path: `/${API_VERSION}/clients/{}/process-sync`,
};

export const MEC_SERVICES = {
    path: `/${API_VERSION}/mec-services`
};

export const CLIENT_CONFIGURATION = {
    path: `/${API_VERSION}/get-client-configuration`
};

export const CLIENT_SYNC_OPTIONS = {
    path: `/${API_VERSION}/get-client-sync-options`
};

export const CLIENT_CLASSIFICATION = {
    name: "clientClassification",
    path: `/${API_VERSION}/clients/{}/classifications`,
};

export const MEMBER_COVERAGES_COUNT = {
    name: "memberCoveragesCount",
    path: `/${API_VERSION}/clients/{}/member-coverages/count`,
};

export const GET_CLIENT_INSURERS = {
    name: "clientInsurers",
    path: `/${API_VERSION}/clients/{}/client-coverages/insurers`,
};
export const SUB_PROCESS_SYNC = {
    name: "subProcessSyncs",
    identifier: "subProcessSyncId",
    path: `/${API_VERSION}/clients/{clientId}/process-sync/{processSyncId}/subprocess-sync`,
};
export const LATEST_DIVISION_SYNCS = {
    name: "latestDivisionSyncs",
    path: `/${API_VERSION_V2}/clients/{}/divisions/sync`
};
export const LATEST_CLASS_SYNCS = {
    name: "latestClassSyncs",
    path: `/${API_VERSION_V2}/clients/{}/classes/sync`
};
export const RESYNC = {
    name: "Resync",
    path: `/${API_VERSION_V2}/sync/resync`
};
export const EMPLOYMENTS = {
    name: "employments",
    identifier: "memberEmploymentId",
    path: `/${API_VERSION}/member-employments`,
};

export const MEMBER_FILES = {
    name: "memberFiles",
    identifier: "memberId",
    path: `/${API_VERSION_V2}/clients/{}/member-files`,
};

export const MEMBER_FILES_REGENERATION = {
    name: "memberFilesRegeneration",
    identifier: "clientId",
    path: `/${API_VERSION_V2}/clients/{}/member-files/regenerate`,
};

export const IS_MINT_ENABLED = {
    name: "mintEnabled",
    path: `/${API_VERSION_V2}/referential-data/mint`,
};

export const GET_CLIENT_COVERAGE_PLAN_ADMINISTRATOR_DATA = {
    name: "getClientCoveragePlanAdministratorData",
    path: `/${API_VERSION_V2}/referential-data/client-coverage-plan-admin`,
};

export const GET_SUPPORT_CONTACT = {
    name: "getSupportContact",
    path: `/${API_VERSION_V2}/referential-data/support-contacts`,
};

export const SEND_MAJOR_CARDS = {
    name: "sendMajorCards",
    identifier: "clientId",
    path: `/${API_VERSION_V2}/clients/{}/member-files/send-major-cards`,
};

export const CLIENT_GUARANTEE_CONFIGURATIONS = {
    name: "clientGuaranteeConfigurations",
    identifier: "clientGuaranteeConfigurationId",
    path: `/${API_VERSION_V2}/clients/{}/guarantees`,
};

export const CLIENT_GUARANTEE_CONFIGURATIONS_BY_GUARANTEE_ID = {
    name: "clientGuaranteeConfigurationsByGuaranteeId",
    identifier: "clientGuaranteeConfigurationId",
    path: `/${API_VERSION_V2}/client-guarantee-configurations/{}/get-by-guarantee-id`,
};


// WEBPACK FOOTER //
// ./src/utils/data/models.js